import { useState } from "react";
import { api } from "../../../../../../../utility/api";
import { descargarReporteExcel } from "../../../helpers/descargarReporteExcel";

export const ReporteCierresMensualesApi = () => {
    const [cargando, setCargando] = useState(false);

    const getReporteCierresMensuales = async (params) => {
        try {
            setCargando(true);
            const response = await api.get(
                "reportes_produccion/cierres_mensuales",
                params,
            );
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            setCargando(false);
        }
    };

    const descargarCierresMensualesExcel = async (params) => {
        try {
            setCargando(true);
            await descargarReporteExcel(
                "reportes_produccion/cierres_mensuales_excel",
                params,
                "cierres_mensuales_produccion.xlsx",
            );
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            setCargando(false);
        }
    };

    return {
        getReporteCierresMensuales,
        descargarCierresMensualesExcel,

        cargando,
    };
};
